import { gql, gqlFetch } from '@/service/gql'

const reportEntityMutation = gql(`
    mutation reportEntity(
        $reportedAsset: ReportedAssetArg
        $reportedOrigin: String
        $reportedType: String
        $addedDetails: String
    ) {
        reportEntity(
            reportedAsset: $reportedAsset
            reportedOrigin: $reportedOrigin
            reportedType: $reportedType
            addedDetails: $addedDetails
        ) {
            reportStatus
        }
    }
`)

export type ReportedEntityType =
    | 'TRACK'
    | 'ALBUM'
    | 'PLAYLIST'
    | 'PODCAST_EPISODE'
    | 'PODCAST_SHOW'
    | 'USER'
    | 'ARTIST'

export interface ReportEntityInput {
    readonly id: string
    readonly type: ReportedEntityType
    readonly label?: string
    readonly addedDetails?: string
}

/**
 * Reports a user-visible entity to the moderation team. Mirrors GH's
 * Report* menu items (Track / Album / Playlist / PodcastEpisode /
 * User / Artist). The gateway routes the report to the moderation
 * pipeline; success surfaces a toast — the resolution happens out
 * of band.
 */
export async function reportEntity(input: ReportEntityInput): Promise<void> {
    await gqlFetch(reportEntityMutation, {
        reportedAsset: {
            id: input.id,
            type: input.type,
            title: input.label ?? null,
        },
        reportedOrigin: 'BULLFROG_WEB',
        reportedType: input.type,
        addedDetails: input.addedDetails ?? null,
    })
}
